import Vue from "vue"
import SvgIcon from "@/components/svgIcon/svgIcon.vue"

Vue.component("SvgIcon", SvgIcon)

const req = require.context("@/assets/icons/svg", true, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
